import blog1 from "../../assets/images/blog/blog-01.jpg";
import blog2 from "../../assets/images/blog/blog-02.jpg";
import blog3 from "../../assets/images/blog/blog-03.jpg";
import blog4 from "../../assets/images/blog/blog-04.jpg";

const BlogContent = [
  {
    images: blog1,
    title: "What to plan before starting a website redesign",
    category: "Web Design",
  },
  {
    images: blog2,
    title: "How clear content helps visitors take action",
    category: "Content Strategy",
  },

  {
    images: blog3,
    title: "Designing a website that feels like your brand",
    category: "Brand Identity",
  },
  {
    images: blog4,
    title: "Why responsive design matters for every business",
    category: "Development",
  },
  {
    images: blog1,
    title: "A practical guide to improving your website's UX",
    category: "User Experience",
  },
  {
    images: blog2,
    title: "Getting your online shop ready for more customers",
    category: "E-commerce",
  },
];

export default BlogContent;